import React, { useState } from "react";
import Input from "../../../components/input";
import { ILoginDetails, TKey } from "../../../types";
import Button from "../../../components/ui/button";
import { displayErrorMsg } from "../../../utils/displayErrorMsg";
import { validateEmail } from "../../../utils/validateEmail";
import { useNavigate } from "react-router-dom";
import { useRequestResetPassword } from "../../../apis/doctor";

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setDetails: React.Dispatch<React.SetStateAction<ILoginDetails>>;
  details: ILoginDetails;
}
const ForgotPasswordForm = ({ setStep, details, setDetails }: IProps) => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const updateState = (name: TKey, value: string) => {
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const { mutate, isPending } = useRequestResetPassword();
  return (
    <div className="w-full flex gap-[24px] flex-col">
      <div>
        <Input
          handleChange={(e) => updateState("email", e)}
          property="email"
          submitting={false}
          value={details.email}
          title="Email"
          placeholder="Enter email"
        />
        {displayErrorMsg("Email can not be empty", details.email, submitting)}
        {details?.email && !validateEmail(details.email) && (
          <div className="text-[red] text-left text-[11px]">
            Enter a valid email
          </div>
        )}
      </div>

      <Button
        theme="primary"
        text="Send link"
        className="w-full rounded-md"
        loading={isPending}
        onClick={() => {
          setSubmitting(true);
          if (validateEmail(details?.email)) {
            mutate(
              {
                email: details?.email,
              },
              {
                onSuccess: () => {
                  setStep((prev) => prev + 1);
                },
              }
            );
          }
        }}
      />
      <Button
        theme="tertiary-primary"
        text="Back to Login"
        className="w-full rounded-md"
        onClick={() => navigate("/login")}
      />
    </div>
  );
};

export default ForgotPasswordForm;
